class ButtonHoverEffect {
  constructor(button) {
    this.button = button;
    this.rect = null;
    this.addListeners();
  }

  addListeners() {
    this.button.addEventListener('mouseenter', () => {
      this.rect = this.button.getBoundingClientRect();
    });

    this.button.addEventListener('mousemove', (e) => {
      this.button.style.setProperty('--hover-x', `${e.clientX - this.rect.left}px`);
      this.button.style.setProperty('--hover-y', `${e.clientY - this.rect.top}px`);
    });
  }
}

const SELECTOR = '.button--primary, .button--secondary';
const initialized = new WeakSet();

function initOne(button) {
  if (initialized.has(button)) return;
  initialized.add(button);
  new ButtonHoverEffect(button);
}

document.querySelectorAll(SELECTOR).forEach(initOne);

// Catches async-mounted buttons (Marketo submit, lazy-loaded sections).
new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.(SELECTOR)) initOne(node);
      node.querySelectorAll?.(SELECTOR).forEach(initOne);
    }
  }
}).observe(document.body, { childList: true, subtree: true });
